// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"63":"app-chart","625":"app-calculator"}[chunkId] + ".js";
};